
import { defineComponent, PropType } from 'vue';

interface TrackItem {
  logisticsStatusName?: string;
  trackTime?: string;
  province?: string;
  city?: string;
  area?: string;
  address?: string;
  numberPlate?: string;
  driver?: string;
  courierPhone?: string;
}

interface TrackData {
  logisticsCompany?: string;
  waybillNo?: string;
  licensePlate?: string;
  driverName?: string;
  driverPhone?: string;
  isSelfDelivery?: boolean;
  trackList?: TrackItem[];
}

export default defineComponent({
  name: 'LogisticsTrack',
  props: {
    trackData: {
      type: Object as PropType<TrackData>,
      default: () => ({})
    }
  },
  computed: {
    trackList(): TrackItem[] {
      return this.trackData?.trackList || [];
    }
  },
  methods: {
    formatTime(time?: string): string {
      if (!time) return '';
      try {
        const d = new Date(time);
        if (isNaN(d.getTime())) return time;
        const pad = (n: number) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      } catch {
        return time;
      }
    },
    getAddress(item: TrackItem): string {
      const parts = [item.province, item.city, item.area, item.address].filter(Boolean);
      return parts.join('');
    },
    copyText(text: string) {
      navigator.clipboard.writeText(text).then(() => {
        // 简单提示
      }).catch(() => {});
    }
  }
});
